import { createSelector } from '@ngrx/store';

import { locationsFiltersState } from '../root';

export const getLocationFiltersPickupMode = createSelector(locationsFiltersState, (locationsFilters) => locationsFilters?.pickupMode || null);
